import React from "react";
import { Link } from 'react-router-dom'
import { Container, Header, Divider, Icon, Menu, Button } from "semantic-ui-react";
import AdsComponent from '../AdsComponent';

const AboutComponent = () => {
  return (
    <div>
      <Menu fixed="top" style={{backgroundColor: "#0d96d4", color:"White"}}>
        <Link to="/"><Menu.Item style={{color:"White"}} link><Icon name='arrow left' /> Home</Menu.Item></Link>
        <Link to="/systems"><Menu.Item style={{color:"White"}} link>Listen</Menu.Item></Link>
      </Menu>
      <div class="horizontal_ad">
      <center>
        <AdsComponent adSlot="7461549169" />
      </center>
      </div>
      <Container text>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
        <ins className="adsbygoogle"
          style={{display: "block"}}
          data-ad-client="ca-pub-7987249781782871"
          data-ad-slot="1779188550"
          data-ad-format="auto"
          data-full-width-responsive="true">
        <script>
          (adsbygoogle = window.adsbygoogle || []).push({});
        </script>
        </ins>
	<h1>Privacy Policy for Scannerlivestream.com</h1>
      <p><strong>Effective Date: April 28, 2025</strong></p>

      <p>
        At Scannerlivestream.com, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information when you visit our website, Scannerlivestream.com, or use our mobile application. We do not directly track or collect personal information from our users, but we use third-party services that may collect certain data as described below.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We do not collect or store personal information (such as your name, email address, or other identifying details) directly from users of Scannerlivestream.com or our mobile app. However, we use third-party services that may collect non-personal information about your visit to improve our site and serve advertisements.
      </p>
      <ul>
        <li>
          <strong>Google Analytics:</strong> We use Google Analytics to collect anonymous information about how visitors use our website, such as the number of visitors, pages viewed, and time spent on the site. This data is aggregated and does not identify individual users. Google Analytics may use cookies or similar technologies to collect this information. For more details, see Google's Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>.
        </li>
        <li>
          <strong>Google Ads (AdWords):</strong> We display advertisements on Scannerlivestream.com through Google Ads. Google may collect information about your device, browser, IP address, or browsing activity to serve personalized ads. This data is managed by Google and is not shared with us. For more information on how Google uses this data, see Google's Advertising Policies: <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/ads</a>.
        </li>
      </ul>

      <h2>2. How We Use Information</h2>
      <p>The information collected by third-party services is used to:</p>
      <ul>
        <li>Improve our website's functionality and user experience (via Google Analytics).</li>
        <li>Generate revenue by displaying relevant advertisements (via Google Ads).</li>
      </ul>
      <p>We do not use any collected data to personally identify or track users.</p>

      <h2>3. Sharing of Information</h2>
      <p>
        We do not share personal information with third parties because we do not collect it. Any data collected by Google Analytics or Google Ads is governed by Google's privacy practices, and we do not have access to identifiable user data from these services.
      </p>

      <h2>4. Cookies and Tracking Technologies</h2>
      <p>
        Our website uses cookies and similar technologies through Google Analytics and Google Ads. These cookies help analyze site performance and deliver personalized ads. You can manage or disable cookies through your browser settings, but this may affect your experience on our site. For more information, see Google's Cookie Policy: <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/cookies</a>.
      </p>

      <h2>5. Your Choices</h2>
      <p>You can opt out of certain data collection:</p>
      <ul>
        <li>
          <strong>Google Analytics:</strong> Use the Google Analytics Opt-Out Browser Add-On: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a>.
        </li>
        <li>
          <strong>Google Ads:</strong> Adjust your ad personalization settings or opt out of personalized ads via Google's Ads Settings: <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">https://adssettings.google.com</a>.
        </li>
      </ul>

      <h2>6. Third-Party Links</h2>
      <p>
        Scannerlivestream.com may contain links to third-party websites. We are not responsible for the privacy practices or content of these sites. We encourage you to review the privacy policies of any third-party sites you visit.
      </p>

      <h2>7. Children's Privacy</h2>
      <p>
        Our website and mobile app are not directed to children under the age of 13. We do not knowingly collect personal information from children. If you believe a child under 13 has provided personal information, please contact us, and we will work to remove it.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have questions about this Privacy Policy, please contact us at:</p>
      <ul>
        <li>Email: records@scannerlivestream.com</li>
        <li>Website: Scannerlivestream.com</li>
      </ul>

      <p>By using Scannerlivestream.com or our mobile app, you agree to the terms of this Privacy Policy.</p>
      </Container>
    </div>
  );
} 


export default AboutComponent;